export const IS_PAID_LOCATION_ENABLED = !["prd", "prdeu"].includes(
  import.meta.env.VITE_APP_ENV,
);

// Past Storms: draw wind swaths with smoothed edges. Display only; saved footprints and counts are unchanged.
// Set to false to draw the raw per-quadrant slices again (this also turns off the edge closing in windSwathClosing.ts).
export const SMOOTH_WIND_SWATHS = true;
